import { createApi } from '@reduxjs/toolkit/query/react';

import { LibraryTag } from 'types';
import { URL } from 'api/constants';

import { apiQuery } from '../../query';

import { TagListResponse } from './types';

const tagType = 'TAGS' as const;

export const tagsApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'tagsApi',
  endpoints: (build) => ({
    list: build.query<LibraryTag[], void>({
      transformResponse: (response: TagListResponse) => response.data,
      query: () => ({
        method: 'get',
        url: URL.LIBRARY_TAGS,
      }),
      providesTags: (result) =>
        result?.length
          ? [
              { id: 'LIST', type: tagType },
              ...result.map(({ id }) => ({ id, type: tagType })),
            ]
          : [{ id: 'LIST', type: tagType }],
    }),
  }),
});

export const { useListQuery: useTagsListQuery } = tagsApi;

export type { TagListResponse };
